export default __webpack_public_path__ + "static/media/Group.40ce616d.svg";